import { render, staticRenderFns } from "./multi-color-selector.vue?vue&type=template&id=5a0d5268&scoped=true&"
import script from "./multi-color-selector.vue?vue&type=script&lang=js&"
export * from "./multi-color-selector.vue?vue&type=script&lang=js&"
import style0 from "./multi-color-selector.vue?vue&type=style&index=0&id=5a0d5268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d5268",
  null
  
)

export default component.exports